<template>
  <v-layout wrap>
    <v-flex sm12>
      <div v-if="hasPrev" class="text-md-center and-divider">{{ $t('EXTSEARCH_ELEMENT_AND') }}</div>
    </v-flex>
    <!-- Field -->
    <!-- {{search}} -->

    <v-flex sm12 md4>
      <v-autocomplete
        dense
        :items="fields"
        return-object
        :placeholder="$t('EXTSEARCH_SELECT_SEARCH_FIELD')"
        v-model="search.field"
        clearable
        @change="dirty=true"
        menu-props="auto"
        :filter="fldFilter"
      >
        <template v-slot:selection="data">
          {{ data.item ? data.item.label : '' }}
        </template>
        <template v-slot:item="data">  
          <!-- Divider and Header-->
          <template v-if="typeof data.item === 'object'">
            <v-list-item-content v-text="data.item.label"/>
          </template>
          <!-- Normal item -->
          <template v-else>
            <!-- {{ data.item }} -->
          </template>
        </template>
      </v-autocomplete>
      <span v-if="debug">{{ search.field }}</span>
    </v-flex>
    <!-- Condition -->
    <v-flex sm12 md2>
      <v-select
        dense
        :items="compares"
        return-object
        placeholder=""
        :disabled="!search.field"
        v-model="search.compare"
        @change="dirty=true"
      >
        <template v-slot:selection="data">
          {{ data.item ? data.item.label : '' }}
        </template>
        <template v-slot:item="data">
          <!-- Divider and Header-->
          <template v-if="typeof data.item === 'object'">
            <v-list-item-content v-text="data.item.label"/>
          </template>
          <!-- Normal item -->
          <template v-else>
            {{ data.item }}
          </template>
        </template>
      </v-select>
      <span v-if="debug">{{ search.compare }}</span>
    </v-flex>
    <!-- Value -->
    <v-flex sm10 md5>
      <template v-if="_valueTextField">
        <v-text-field
          v-for="(value, i) in search.values"
          :key="i"
          dense
          placeholder=""
          :disabled="!search.compare"
          v-model="search.values[i]"
          :append-icon="i < search.values.length-1 ? 'mdi-close' : ''"
          @click:append="removeValue(i)"
          @change="dirty=true"
        >
          <template slot="append-outer">
            <!-- <v-progress-circular
              size="24"
              color="info"
              indeterminate
            ></v-progress-circular> -->
            <v-btn small v-if="i==search.values.length-1" depressed class="or" :disabled="!value" @click="addValue()">{{ $t('EXTSEARCH_MULTITEXT_OR') }}</v-btn>
          </template>
        </v-text-field>
      </template>
<!-- {{search.values}}
{{select}} -->

      <v-autocomplete
        v-if="_valueSelect"
        dense
        :multiple="select_multiple"
        :items="select"
        placeholder=""
        :disabled="!search.compare"
        v-model="search.values"
        @change="dirty=true"
        menu-props="auto"
      >
      </v-autocomplete>
      <YMDHI
        v-if="_valueDate"
        :value="!search.compare"
        :date="search.date"
        :debug="debug"
        @change="dirty=true"
      />
      <!-- <v-autocomplete
        v-if="_valueCatlist"
        dense
        :items="catlist"
        placeholder=""
        :multiple="select_multiple"
        :disabled="!search.compare"
        v-model="search.values"
        @change="dirty=true"
        menu-props="auto"
      >
      </v-autocomplete> -->
      <v-text-field
        v-if="_valueCatlist"
        :value="categoryNames()"
        :readonly="true"
        @click="onHitCategory()"
      >
      </v-text-field>
      <v-text-field
        v-if="_valueCountrylist"
        :value="countryNames()"
        :readonly="true"
        @click="onHitCountry()"
      >
      </v-text-field>
      <span v-if="debug">{{ search.values }}</span>
    </v-flex>
    <v-flex sm2 md1 class="row-actions pa-0">
      <v-btn small icon @click="onRemove()"><v-icon>mdi-minus-circle-outline</v-icon></v-btn>
      <v-btn v-if="hasAdd" small icon @click="onAdd()"><v-icon>mdi-plus-circle-outline</v-icon></v-btn>
    </v-flex>

    <CategorySelField ref="categorySel" @select="onCategorySel"></CategorySelField>
    <CountrySelField ref="countrySel" @select="onCountrySel"></CountrySelField>

  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import { selectValues } from '../config/SelectValues'

import YMDHI from "./common/YMDHI";
import CategorySelField from "./CategorySelField";
import CountrySelField from "./CountrySelField";

export default {
  name: 'SearchViewBlockItem',
  components: {
    CategorySelField,
    CountrySelField,
    YMDHI
  },
  props: ['hasPrev', 'aSearch', 'hasAdd', 'debug', 'fLoading', 'isDirty'],
  data() {
    return {
      dirty: false,
      def_compares: require('../config/compares.json'),
      // def_select_values: require('../config/select_values.json') // computed
    }
  },
  computed: {
    ...mapGetters(['data', 'countries', 'categoryDict']),
    search() {
      return this.aSearch
    },
    def_select_values() { return selectValues.get(this) },
    fields() {
      let fields = []
      // if (this.data.fields.length) {
      //   fields.push({ header: '' })
      // }
      fields.push(...this.data.fields
        .map(a => ({ ...a, value: `i${a.value}`, label: this.$t(a.text) }))) // alter value so the v-select/v-autocomplete component can show all items (prevent duplicate IDs)

      if (this.data.categories.length) {
        fields.push({ header: this.$t('CONTACT_CATEGORIES') })
      }
      fields.push(...this.data.categories
        .map(a => ({ ...a, value: `c${a.value}`}))) // alter value so the v-select/v-autocomplete component can show all items (prevent duplicate IDs)

      if (this.data.custom_fields.length) {
        fields.push({ header: this.$t('CONTACT_FREE_FIELDS') })
      }
      fields.push(...this.data.custom_fields
        .map(a => ({ ...a, value: `f${a.value}`}))) // alter value so the v-select/v-autocomplete component can show all items (prevent duplicate IDs)

      if (this.data.additional_fields.length) {
        fields.push({ header: this.$t('EXTSEARCH_NOTES_SEPARATOR') })
      }
      fields.push(...this.data.additional_fields
        .map(a => ({ ...a, value: `a${a.value}`}))) // alter value so the v-select/v-autocomplete component can show all items (prevent duplicate IDs)

      return fields
    },
    compares() {
      let compares = []
      const group = this.search.field ? this.search.field.datatype : 'default'
      compares = this.def_compares[group] && Array.isArray(this.def_compares[group])
        ? this.def_compares[group].filter(a => a.id.indexOf('_') !== 0) : []
      compares = compares.map(a => ({ ...a, label: this.$t(a.text) }))
      return compares
    },
    select() {
      if (this.search.field.datatype === 'country') {
        return this.countries
      }
      const field_id = this.search.field ? this.search.field.id : null
      return field_id && this.def_select_values[field_id] && Array.isArray(this.def_select_values[field_id]) ? this.def_select_values[field_id].filter(a => a.id.indexOf('_') !== 0) : []
    },
    select_multiple() {
      // return this.search.field.multiple === '1' || this.search.compare.id === 'equals' || this.search.compare.id === 'equals-not'
      return this.search.field.multiple === '1' // don't include compare "is" or "is not", only "multiple"
    },
    catlist() {
      const field_id = this.search.field ? this.search.field.id : null
      const category = field_id && this.data && this.data.categories
                ? this.data.categories.find(a => a.id === field_id)
                : null
      return category && category.children && Array.isArray(category.children)
                ? category.children.map(a => Object.assign(a, {id: a.id, value: a.id, label: a.name, text: a.name}))
                : []
    },

    _valueTextField() {
      return this.search.field
        && (
          this.search.field.datatype === 'default'
          || this.search.field.datatype === 'relation'
          || this.search.field.datatype === 'notice'
          || this.search.field.datatype === 'free'
        )
        && (
          !this.search.compare
          || !['null', 'null-not'].includes(this.search.compare.id)
        )
    },
    _valueSelect() {
      return this.search.field
        && ( this.search.field.datatype === 'select'
        )
        && (
          !this.search.compare
          || !['null', 'null-not'].includes(this.search.compare.id)
        )
    },
    _valueDate() {
      return this.search.field
        && this.search.field.datatype === 'date'
        && (
          !this.search.compare
          || !['null', 'null-not'].includes(this.search.compare.id)
        )
    },
    _valueCatlist() {
      return this.search.field
        && this.search.field.datatype === 'catlist'
        && (
          !this.search.compare
          || !['null', 'null-not'].includes(this.search.compare.id)
        )
    },
    _valueCountrylist() {
      return this.search.field
        && this.search.field.datatype === 'country'
        && (
          !this.search.compare
          || !['null', 'null-not'].includes(this.search.compare.id)
        )
    },
  },
  watch: {
    isDirty(val) {
      if (!val) {
        this.dirty = false
      }
    },
    dirty(val) {
// console.log('watch dirty', val)
      if (val) {
        this.$emit('dirty')
      }
    },
    'search.field'(val, old) {
// console.log('watch search.field', val, old)
      if (!this.fLoading) {
        if (!val) {
          this.search.compare = null
        } else {
          // clear compare and values only if coming from "nothing" or switching field types
          if (!old || !val || val.datatype !== old.datatype) {
            this.search.compare = this.compares[0] || null
            this.search.values = ['']
          }
          // clear Date only if not switching to another "date" field
          if (!this._valueDate) {
            this.search.date.year = null
          }
        }
        this.dirty = true
      }
    },
    'search.compare'(val) {
// console.log('watch search.compare', val)
      if (!this.fLoading) {
        if (this.search.field && this.search.field.datatype === 'select') {
          this.search.values = this.select[0].value
        } else {
          // clear values only if "no value" compare
          if (!val || ['null', 'null-not'].includes(val.id)) {
            this.search.values = ['']
          }
        }
        // this.search.date.year = null
        this.dirty = true
      }
    },
    'search.date.year'(val) {
// console.log('watch search.date.year', val)
      if (!this.fLoading) {
        if (!val) {
          this.search.date.month = null
        }
        this.dirty = true
      }
    },
    'search.date.month'(val) {
// console.log('watch search.date.month')
      if (!this.fLoading) {
        if (!val) {
          this.search.date.day = null
        }
        this.dirty = true
      }
    },
    'search.date.day'(val) {
// console.log('watch search.date.day')
      if (!this.fLoading) {
        if (!val) {
          this.search.date.hour = null
        }
        this.dirty = true
      }
    },
    'search.date.hour'(val) {
// console.log('watch search.date.hour')
      if (!this.fLoading) {
        if (!val) {
          this.search.date.minute = null
        }
        this.dirty = true
      }
    },
    'search.value'() {
// console.log('watch search.value')
      if (!this.fLoading) {
        this.dirty = true
      }
    },
  },
  methods: {
    fldFilter(item, queryText) {
      return item.label && item.label.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
    },
    onHitCategory() {
      const categoryId = this.search.field.id
      this.$refs.categorySel.onOpen(categoryId, this.search.values, true)
    },
    onCategorySel({ categById }) {
      this.search.values = categById
    },
    categoryNames() {
      const categoryId = this.search.field.id
      const category = categoryId
                ? this.data.categories.find(a => a.id === categoryId)
                : null
      return category && category.children && Array.isArray(category.children)
                ? category.children.filter(a => this.search.values.includes(a.id)).map(a => this.categoryDict[a.id].name)
                : []
    },
    onHitCountry() {
      this.$refs.countrySel.onOpen(this.search.values)
    },
    onCountrySel({ countryIds }) {
      this.search.values = countryIds
    },
    countryNames() {
      return this.countries.filter(a => this.search.values.includes(a.id)).map(a => a.name).join(', ');
    },
    addValue() {
      this.search.values.push('')
    },
    removeValue(idx) {
      idx > -1 && this.search.values.splice(idx, 1)
    },
    onAdd() {
      this.$emit('add')
    },
    onRemove() {
      this.$emit('remove')
    },
  }
}
</script>

<style scoped lang="scss">
.and-divider {
  width: 5cm;
  // margin: 0px auto;
  // border-radius: 8px;
}
.v-text-field {
  padding-top: 0;
  margin-top: 0;
}
// .v-input {
//   font-size: 0.8em;
// }
.v-select { // TODO: needs improvement
  .v-select__selections {
    word-wrap: none;
    text-overflow: ellipsis;
  }
}
.v-select-list {
  .v-list__tile {
    font-size: 0.8em;
    height: 26px !important;
    padding: 0 8px;
  }
}
.or {
  min-width: 0;
}
.row-actions .v-btn {
  margin-left: 0;
  margin-right: 0;
}
</style>
